<template>
<div class="chapter">
<div class="inner_page">
<a id="pvii"></a>
<blockquote class="sink">
<p class="center "><span class="smallcaps">FOR</span></p>
<p class="center "><span class="smallcaps">ED AND EVY HALPERT</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?1eb7bc01